import React from 'react';

/** Normalise LLM text so bullets and paragraphs break onto separate lines. */
export function normalizeMessageText(text) {
    if (!text || typeof text !== 'string') return '';
    let s = text.replace(/\r\n/g, '\n').trim();
    s = s.replace(/([.?!])\s*•\s*/g, '$1\n\n• ');
    s = s.replace(/([^\n])\s+•\s+/g, '$1\n• ');
    s = s.replace(/([^\n])\s+-\s+(?=[A-Za-z])/g, '$1\n• ');
    s = s.replace(/\n-\s+/g, '\n• ');
    s = s.replace(/\n{3,}/g, '\n\n');
    return s;
}

function parseBlocks(text) {
    const normalized = normalizeMessageText(text);
    const blocks = [];
    let listItems = [];

    const flushList = () => {
        if (listItems.length) {
            blocks.push({ type: 'list', items: [...listItems] });
            listItems = [];
        }
    };

    for (const line of normalized.split('\n')) {
        const trimmed = line.trim();
        if (!trimmed) {
            flushList();
            continue;
        }
        const bulletMatch = trimmed.match(/^[•·\-*]\s+(.+)$/);
        if (bulletMatch) {
            listItems.push(bulletMatch[1]);
        } else {
            flushList();
            blocks.push({ type: 'paragraph', text: trimmed });
        }
    }
    flushList();
    return blocks;
}

/**
 * Renders assistant/user message text with paragraphs and bullet lists.
 * @param {boolean} inverted - light text on dark bubble (user messages)
 */
export default function FormattedMessageContent({ content, className = '', inverted = false }) {
    const blocks = parseBlocks(content);

    if (blocks.length === 0) {
        return <p className={className} />;
    }

    const paraClass = inverted ? 'text-white/95' : 'text-inherit';
    const listClass = inverted ? 'text-white/95 marker:text-white/70' : 'text-inherit marker:text-slate-500';

    return (
        <div className={`space-y-2.5 ${className}`}>
            {blocks.map((block, i) => {
                if (block.type === 'list') {
                    return (
                        <ul key={i} className={`list-disc pl-5 space-y-1.5 text-sm leading-relaxed ${listClass}`}>
                            {block.items.map((item, j) => (
                                <li key={j}>{item}</li>
                            ))}
                        </ul>
                    );
                }
                return (
                    <p key={i} className={`text-sm leading-relaxed ${paraClass}`}>
                        {block.text}
                    </p>
                );
            })}
        </div>
    );
}
